import { RegisteredComponent } from "@builder.io/sdk-react";

export const iconSelectionIdentificatorBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "IconSelectionIdentificator",
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/editor-6/dots-horizontal-3.png",
  canHaveChildren: false,
  inputs: [
    {
      name: "icons",
      type: "list",
      subFields: [
        {
          name: "icon",
          type: "AprimoAssetSelector",
          helperText: "Select an SVG icon from the DAM (Aprimo).",
          localized: false,
        },
      ],
      defaultValue: [],
    },
  ],
  requiresParent: {
    message:
      "This component must be nested within the Horizontal Tab component",
    component: "Horizontal Tab",
  },
};
